import * as React from "react";

import { OnboardingStatusContext, StatusContext } from "client/context";

export function useOnboardingStatusContext(): OnboardingStatusContext {
  const ctx = React.useContext(StatusContext);
  if (ctx === undefined) {
    throw new Error(
      `useOnboardingStatusContext must be used within a StatusContext provider`
    );
  }
  return ctx;
}
